import api from "PFCore/api";
import { CurrentProfile } from "PFCore/types";

export const fetchCurrentProfile = () =>
  api<CurrentProfile>({
    url: "me"
  });
